import { Stack, Typography } from '@mui/material';
import type { BookingStage } from 'api-client/models';

type Props = { changes: Record<string, unknown>; stages?: BookingStage[] };
export function BookingChangeSummary({ changes, stages = [] }: Props) {
  const labels: Record<string, string> = {
    hold_date: 'Requested date', load_in_time: 'Load-in', soundcheck_time: 'Soundcheck', doors_time: 'Doors',
    show_time: 'Show time', end_time: 'End time', show_capacity: 'Capacity', attendance: 'Attendance',
  };
  const terms = changes.booking_terms as Record<string, string> | undefined;
  const settlement = changes.shared_settlement as Record<string, unknown> | undefined;
  const stage = stages.find(item => item.id === changes.stage);
  const settlementLabels: Record<string, string> = {
    deposit_paid: 'Deposit paid', rental_paid: 'Rental fee paid', ticket_sales: 'Shared ticket sales',
    settled: 'Settlement complete', settlement_date: 'Settlement date',
  };
  return <Stack spacing={1}>
    {Object.entries(labels).filter(([key]) => key in changes).map(([key, label]) => <Typography key={key}>{label}: {String(changes[key] ?? 'Not set')}</Typography>)}
    {Boolean(changes.stage) && <Typography>Requested stage: {stage ? `${stage.venueName} — ${stage.name}` : String(changes.stage)}</Typography>}
    {terms && <Typography>{terms.deal_type === 'flat_rental' ? `Flat rental: ${terms.currency} ${terms.rental_fee}`
      : `Revenue sharing: host ${terms.host_percentage}% of ${terms.settlement_basis === 'net_ticket_sales' ? 'ticket sales minus agreed expenses' : 'gross ticket sales'}`}</Typography>}
    {terms && <>
      <Typography>Currency: {terms.currency} · Deposit: {terms.deposit_amount ?? '0.00'}</Typography>
      <Typography>Deposit due: {terms.deposit_due_date ?? 'Not set'}</Typography>
      <Typography>Cancellation: {terms.cancellation_terms || 'Not set'}</Typography>
      <Typography>Contact: {terms.booking_contact || 'Not set'}</Typography>
      <Typography>Production: {terms.production_requirements || 'Not set'}</Typography>
    </>}
    {settlement && <>
      {Object.entries(settlementLabels).filter(([key]) => key in settlement).map(([key, label]) => <Typography key={key}>
        {label}: {typeof settlement[key] === 'boolean' ? (settlement[key] ? 'Yes' : 'No') : String(settlement[key] ?? 'Not set')}
      </Typography>)}
      {'approved_expenses' in settlement && <Typography>Agreed expenses: {(settlement.approved_expenses as { description: string; amount: string }[])
        .map(expense => `${expense.description}: ${expense.amount}`).join('; ') || 'None'}</Typography>}
    </>}
  </Stack>;
}
